import { AxiosResponse } from 'axios'
import { ParseKeys } from 'i18next'

export class AccessDenied<ErrorReason = unknown> extends Error {
  public response?: AxiosResponse<ErrorReason>
  constructor(response?: AxiosResponse<ErrorReason>) {
    super()
    this.response = response
  }
}

export enum AccessDeniedReasonsEnum {
  OwnerRestricted = 'owner_restricted',
  CommunityOwnerBlocked = 'community_owner_blocked',
  Deactivated = 'course_deactivated',
  LectureDeactivated = 'lecture_deactivated',
  BlockedByProgress = 'progress_blocked',
  PurchaseRequired = 'purchase_required',
  BlockedByQuiz = 'quiz_was_not_passed',
  QuizHasBeenPassed = 'quiz_has_been_passed',
  MutedReason = 'muted_reason',
  CourseEditorTypeMismatch = 'course_editor_type_mismatch',
  AssignmentReviewed = 'assignment_reviewed',
  AssignmentNotSubmitted = 'assignment_not_submitted',
  AssignmentUnderReview = 'assignment_under_review',
}

export function getAccessDeniedText(reason?: AccessDeniedReasonsEnum | null): ParseKeys {
  if (!(reason && Object.values(AccessDeniedReasonsEnum).includes(reason))) {
    return '403 - Access Denied' as ParseKeys
  }

  return 'core.error.access_unavailable'
}
